module.exports = require("js-yaml");


//////////////////
// WEBPACK FOOTER
// external "js-yaml"
// module id = 244
// module chunks = 0